import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DestinationsService } from 'ldt-data-deliveries-api';
import { AuthService } from '../auth/service/auth.service';

// Land orgs that already have configured integrations on the Configured tab;
// everyone else starts on Available. Always returns a UrlTree, so it can guard
// a component-less route.
export const integrationsLandingGuard: CanActivateFn = () => {
  const destinations = inject(DestinationsService);
  const auth = inject(AuthService);
  const router = inject(Router);

  const orgId = auth.getSelectedOrgIdValue;
  if (!orgId) {
    return of(router.parseUrl('/invite'));
  }

  const base = '/' + orgId + '/integrations/';
  return destinations.listDestinations(orgId, { size: 100 }).pipe(
    map((data) => (data.items || []).some((item) => item.deleted_at === null)),
    map((hasConfigured) =>
      router.parseUrl(base + (hasConfigured ? 'configured-integrations' : 'available-integrations'))
    ),
    catchError(() => of(router.parseUrl(base + 'available-integrations')))
  );
};
